$(function () {
    addDateField("day-of-birth");
    addDateField("date-employed");
});

function addDateField (nameHyphen) {
    var nameUnderscore = nameHyphen.replace(/-/g,"_");

    ["new","edit"].forEach(function (field) {
        if ($('#'+nameHyphen+'-'+field).length > 0) {
            if ($('#'+nameHyphen+'-'+field).data(nameHyphen).length > 0) {
                var value = $('#'+nameHyphen+'-'+field).data(nameHyphen).split("-");
                var date
                if (value[2].length == 4) {
                    date = new Date(value[2], value[1] - 1, value[0])
                } else {
                    date = new Date(value[0], value[1] - 1, value[2])
                }

                $('#'+nameHyphen+'-'+field).dxDateBox({
                    name: nameUnderscore,
                    value: date,
                    displayFormat: "d-M-y",
                });
            } else {
                $('#'+nameHyphen+'-'+field).dxDateBox({
                    name: nameUnderscore,
                    displayFormat: "d-M-y",
                });
            }
        }
    });
}

/**
 #example edit field
 <div class="form-group">
 {{ Form::label('date_employed', 'Datum in dienst') }}
 <div id="date-employed-edit" class="w-100" data-date-employed="{{old('date_employed') ?? ($employee->date_employed ? $employee->date_employed->format('d-m-Y') : null)}}"></div>
 </div>

 #example create field
 <div class="form-group">
 {{ Form::label('day_of_birth', 'Verjaardag') }}
 <div id="day-of-birth-new" class="w-100" data-day-of-birth="{{old("day_of_birth")}}" class="form-control"></div>
 </div>
 **/



// WEBPACK FOOTER //
// ./resources/js/components/datefields.js